import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';

import { EntitlementRole, TinAccess } from '../manage-access.model';

import {
  JOB_ROLE_DELEGATE_NAME,
  COLLABORATIVE_CARE_ENTITLEMENT,
  CLAIM_STATUS_NOTIFICATIONS,
} from '../manage-access.constant';

@Component({
  selector: 'cigna-entitlement-group',
  templateUrl: './entitlement-group.component.html',
  styleUrls: ['./entitlement-group.component.css'],
})
export class EntitlementGroupComponent {
  @Input() activeTin: TinAccess;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showRevert = false;
  @Input() allEntitlements: EntitlementRole[] = [];
  @Input() currentEntitlements: EntitlementRole[] = [];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showApplyJobRole = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() bulkEdit = false;
  @Input() hasClaimsMcNotification = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _hasClaimsMCJob: boolean;
  @Input() userJobRole: string;

  @Output() selectionsChange = new EventEmitter();
  @Output() revertToExisting = new EventEmitter();
  @Output() applyByJobRole = new EventEmitter();

  @ViewChildren('entitlementInput', { read: ElementRef })
  private entitlementInputs: QueryList<ElementRef>;
  @ViewChildren('functionsInput', { read: ElementRef })
  private functionsInput: QueryList<ElementRef>;

  JOB_ROLE_DELEGATE_NAME = JOB_ROLE_DELEGATE_NAME;
  CLAIM_STATUS_NOTIFICATIONS = CLAIM_STATUS_NOTIFICATIONS;

  activeEntitlement(id: number): boolean {
    return (
      this.currentEntitlements.findIndex(
        (entitlement) => entitlement.id === id,
      ) !== -1
    );
  }

  activeFunction(id: number, f: string): boolean {
    const currentEntitlement = this.currentEntitlements.find(
      (entitlement) => entitlement.id === id,
    );
    if (currentEntitlement && currentEntitlement.functions) {
      return currentEntitlement.functions.some(
        (entFunction) => entFunction.name === f,
      );
    }
    return false;
  }

  applyByRole(): void {
    this.applyByJobRole.emit();
  }

  revert(): void {
    this.revertToExisting.emit();
  }

  functionChange(entitlement: EntitlementRole) {
    const selected = this.functionsInput
      .filter((cb) => cb.nativeElement.checked)
      .map((cb) => cb.nativeElement.value)
      .map((val) =>
        entitlement.functions
          ? entitlement.functions.find((f) => f.name === val)
          : [],
      )
      .filter((f) => f);

    const selectedEntitlement = this.entitlementInputs.find(
      (cb) => parseInt(cb.nativeElement.value, 10) === entitlement.id,
    );

    if (selectedEntitlement) {
      // entitlement selection should not be reset to false on removing function except for collaborative care
      selectedEntitlement.nativeElement.checked =
        selected.length > 0 ||
        (selectedEntitlement.nativeElement.checked &&
          entitlement.name !== COLLABORATIVE_CARE_ENTITLEMENT);
    }

    this.emitChange();
  }

  entitlementChange(entitlement: EntitlementRole): void {
    // collaborative care entitlement should update SCC oncology function
    if (
      entitlement?.name === COLLABORATIVE_CARE_ENTITLEMENT &&
      entitlement?.functions?.length
    ) {
      this.functionsInput.forEach((cb, _i) => {
        if (
          entitlement.functions?.some((f) => cb.nativeElement.value === f.name)
        ) {
          cb.nativeElement.checked = !cb.nativeElement.checked;
        }
      });
    }
    this.emitChange();
  }

  emitChange(): void {
    const checkedFunctions = this.functionsInput
      .filter((cb) => cb.nativeElement.checked)
      .map((cb) => cb.nativeElement.value);

    const selections = this.entitlementInputs
      .filter((cb) => cb.nativeElement.checked)
      .map((cb) => parseInt(cb.nativeElement.value, 10))
      .map((val) =>
        this.allEntitlements.find((entitlement) => entitlement.id === val),
      )
      .map((entitlement) => {
        if (entitlement?.functions?.length) {
          return {
            ...entitlement,
            functions: entitlement.functions.filter((f) =>
              checkedFunctions.includes(f.name),
            ),
          };
        }
        return entitlement;
      });

    this.selectionsChange.emit(selections);
  }

  isEntitlementDisabled(entitlement: EntitlementRole, bulk: boolean) {
    if (
      bulk &&
      (entitlement.name === JOB_ROLE_DELEGATE_NAME ||
        (entitlement.name === COLLABORATIVE_CARE_ENTITLEMENT &&
          entitlement?.functions?.length))
    ) {
      return true;
    }
    if (
      entitlement.name === COLLABORATIVE_CARE_ENTITLEMENT &&
      this.activeTin &&
      (!this.activeTin.entitlements?.length ||
        !this.activeTin.entitlements.some(
          (entlmnt) => entlmnt.name === COLLABORATIVE_CARE_ENTITLEMENT,
        ))
    ) {
      return true;
    }

    return false;
  }
}
